var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.customs)?_c('div',{staticClass:"flex",class:[_vm.customs.hoverAnimation, _vm.align, (_vm.getScale > 1 && _vm.overflowScale) ? 'overflow-hidden' : ''],style:({..._vm.shapeShadow, ..._vm.radius})},[_c('b-img',{style:(_vm.styles),attrs:{"alt":_vm.customs.alt,"rounded":_vm.shape,"src":_vm.src,"fluid":""}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }